import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { IpPublic } from '@search-bar/entities/ip-public';
import { searchBarApi } from '@search-bar/search-bar.api';


@Injectable()
export class SearchIpService {

  constructor(private http: HttpClient) { }

  public fetchIp(): Observable<IpPublic> {
    return this.http.get<IpPublic>(searchBarApi.ip_public.url);
  }
}
